const Header = () => import(/* webpackChunkName = "c-header" */ '@/components/Header')
export default {
  name: 'App',
  components: {
    Header
  },
  created () {
  }
}
